export const NO_APLICA = 'NO APLICA';
export const NO_EVALUA = 'NO SE EVALÚA';